// extracted by mini-css-extract-plugin
export default {"user-icon-wrapper":"user-icon-wrapper--fpAXh","hist":"hist--bfirj","transparentTable":"transparentTable--SVyJG"};